angular.module('impactx.company').controller('CompanyInterfaceCtrl', [
    '$scope',
    'dataGen',
    'TranslationService',
    '$routeParams',
    'BackService',
    'ToastService',
    'ToolbarService',
    'PartialDialogsService',
    CompanyInterfaceCtrl
]);

function CompanyInterfaceCtrl($scope, dataGen, TranslationService, $routeParams, BackService, ToastService, ToolbarService, PartialDialogsService) {
    var self = this;
    $scope.label_save = TranslationService.get('save');

    var companyId = $routeParams.id;
    dataGen.getData($scope, {id: companyId}, "/company/interface/view").then(function () {
        $scope.trns.save = TranslationService.get('save');
        $scope.trns.required = TranslationService.get('required');
        $scope.trns.noSelectedItemMessage = TranslationService.get('noSelectedItemMessage');
        defineButtons();
    });

    self.savePageData = function ($event) {
        return dataGen.postAsForm($scope, {companyRelation: $scope.data}, "/company/interface/save").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.COMPANY, companyId, 'companyinterface');
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.savePageData,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }
}